export default "__VITE_ASSET__NHG6v$th__"